export enum WeekDay {
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY
}

export interface Month {
  order: number
  name: string
}

export interface CutOff {
  additionaDays: string
  beforeAdditionalDays: string
  customer: string
  cutOffTime: string
  plant: string
  status: string
  timeZone: string
  weekDays?: string[]
}

export interface UserCutoffTime {
  additionaDays: number
  beforeAdditionalDays: number
  cutOffTime: string
  timeZone: string
  allowedDeliveryWeekDays: string[] | null
}
